export enum UrlPathnameEnum {
  Authorize = 'authorize',
  BookedOrder = 'booked-order',
  Confirmation = 'confirmation',
  Login = 'login',
  Overview = 'overview',
  PassengerChange = 'passenger-change',
  PassengerChangeEdit = 'passenger-change/edit',
  PassengerChangeOverview = 'passenger-change/overview',
  Extras = 'extras',
  ExtrasPageCreate = 'extras/create',
  ExtrasPageOverview = 'extras/overview',
  Refresh = 'refresh',
  Result = 'result',
  Token = 'token',
  CommonOrder = 'order',
  SplitPnr = 'split-pnr',
  OrderAction = 'orderWithActionInfo',
  FlightIndex = 'selectedFlightIndex',
  OrderReference = ':orderReference',
  Finalize = 'finalize',
  Cancel = 'cancel',
  OptionConfirmation = 'confirmation',
}
export type UrlPathnameEnumType = keyof typeof UrlPathnameEnum;
